import { Component } from '@angular/core';

/**
 * Demonstrate the usage of {@link DropzoneComponent}
 */
@Component({
  templateUrl: './dropzone-demo.component.html',
  styleUrls: ['./dropzone-demo.component.scss'],
})
export class DropzoneDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/file-utilities/dropzone/dropzone-demo.component.ts